const state = {
    pid: localStorage.getItem('pid') || ''
}
const mutations = {
    SET_PID: (state, pid) => {
        state.pid = pid
    }
}
const actions = {
    setPid({
        commit
    }, result) {
        commit("SET_PID", result || pid)
        localStorage.setItem('pid', result)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}